import React from 'react';
import { HEX_ALPHA } from '../../utils/constants';
import { isMobile } from '../../../utils/screen';


function BgImg({
	children,
	img,
	color,
	classNameBG = 'w-full',
	classNameBGMobile = 'w-full bg-cover bg-center',
	classNameDIV = 'w-full'
}) {
	/* Default values for the styles */
	const defaultStyleBG = {
		backgroundImage: `url(${img})`,
	};
	const defaultStyleDIV = {
		backgroundColor: `${color}${HEX_ALPHA[75]}`,
	};

	return (
		<div
			id='BgImg'
			className={isMobile ? classNameBGMobile : classNameBG}
			style={defaultStyleBG}
		>
			<div
				id='BgImgChildDiv'
				className={classNameDIV}
				style={defaultStyleDIV}
			>
				{children}
			</div>
		</div>
	);
}

export default BgImg;
